import React, { useRef, useEffect } from "react";

const TextareaAutoajustable = ({ ...props }) => {
  const textareaRef = useRef(null);

  const ajustarAltura = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    ajustarAltura();
  });

  return (
    <textarea
      ref={textareaRef}
      onInput={ajustarAltura}
      rows={1}
      style={{
        resize: "none",
        overflow: "hidden",
        height: "auto",
        ...props.style,
      }}
      {...props}
    />
  );
};

export default TextareaAutoajustable;
